module.exports = __webpack_public_path__ + "h5/img/summer-title2-1.b9faaa61.png";